import { render, staticRenderFns } from "./EEscolhaBimestre.vue?vue&type=template&id=4721b716"
import script from "./EEscolhaBimestre.vue?vue&type=script&lang=js"
export * from "./EEscolhaBimestre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports